export const PROJECT_TYPES = {
  CULTURE_PROJECT: 'cultural_project',
  FEEDBACK_FRAMEWORK: 'feedback_framework',
};

export const PROJECT_TYPE_LABELS = {
  [PROJECT_TYPES.CULTURE_PROJECT]: 'Cultural Project',
  [PROJECT_TYPES.FEEDBACK_FRAMEWORK]: 'Feedback Framework',
};

export const PROJECT_STATUSES = {
  DRAFT: 'Draft',
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
  DELETED: 'Deleted',
};

export const NON_EDITABLE_PROJECT_STATUSES = [PROJECT_STATUSES.ACTIVE, PROJECT_STATUSES.ARCHIVED];

export const PROJECT_NAME_REQUIRED_ERROR = 'Please enter a name';
export const DUPLICATED_PROJECT_NAME_ERROR = 'Please rename the project';

export const CHIP_COLOR_BY_PROJECT_STATUS = {
  [PROJECT_STATUSES.ACTIVE]: 'success',
  [PROJECT_STATUSES.DRAFT]: 'warning',
  [PROJECT_STATUSES.ARCHIVED]: 'error',
};
